module.exports = __webpack_public_path__ + "img/marcador.961b63a7.svg";